import { Integration } from "./Integration";

const ABOUT_YOU_API_KEY = {
    integrations: [Integration.ABOUT_YOU, Integration.ABOUT_YOU_PAYMENTS],
    identifier: "ABOUT_YOU_API_KEY",
    name: "About You (API-Schlüssel)",
};

const ADYEN = {
    integrations: [Integration.ADYEN],
    identifier: "ADYEN",
    name: "Adyen",
};

const AMAZON = {
    integrations: [
        Integration.AMAZON,
        Integration.AMAZON_ORDER,
        Integration.AMAZON_PAYOUT,
        Integration.AMAZON_PAY,
        Integration.AMAZON_PAY_V2,
    ],
    identifier: "AMAZON",
    name: "Amazon",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/amazon-seller-central#amazon-shop-order",
};
const AMAZON_PAY = {
    integrations: [Integration.AMAZON_PAY],
    identifier: "AMAZON_PAY",
    name: "Amazon Pay",
    helpUrl:
        "https://developer.amazon.com/de/docs/amazon-pay-checkout/get-set-up-for-integration.html#5-get-your-public-key-id",
};
const AMAZON_PAY_V2 = {
    integrations: [Integration.AMAZON_PAY_V2],
    identifier: "AMAZON_PAY_V2",
    name: "Amazon Pay (V2)",
};
const BILLBEE = {
    integrations: [Integration.BILLBEE],
    identifier: "BILLBEE",
    name: "Billbee",
    helpUrl: "https://hilfe.billbee.io/article/444-api-zugriff-einrichten",
};
const BRAINTREE = { integrations: [Integration.BRAINTREE], identifier: "BRAINTREE", name: "Braintree" };
const CHARGEBEE = {
    integrations: [Integration.CHARGEBEE],
    identifier: "CHARGEBEE",
    name: "Chargebee",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/chargebee#anleitungen",
};
const FASTBILL = { integrations: [Integration.FASTBILL], identifier: "FASTBILL", name: "Fastbill" };
const GOCARDLESS = {
    integrations: [Integration.GOCARDLESS],
    identifier: "GOCARDLESS",
    name: "GoCardless",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/gocardless-api-anbindung",
};
const DATEV_UO = {
    integrations: [],
    identifier: "DATEV_UO",
    name: "DATEV Unternehmen Online",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/datev",
};
const DATEV_UO_REF = {
    integrations: [],
    identifier: "DATEV_UO_REF",
    name: "DATEV Unternehmen Online",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/datev",
};
const KLARNA = {
    integrations: [Integration.KLARNA],
    identifier: "KLARNA",
    name: "Klarna",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/klarna-api-mit-pathway-verbinden",
};
const LEX_OFFICE = { integrations: [Integration.LEX_OFFICE], identifier: "LEX_OFFICE", name: "LexOffice" };
const MOLLIE = {
    integrations: [Integration.MOLLIE],
    identifier: "MOLLIE",
    name: "Mollie",
};
const MOLLIE_ACCESS_KEY = {
    integrations: [Integration.MOLLIE],
    identifier: "MOLLIE_ACCESS_KEY",
    name: "Mollie (Access Token)",
};
const OTTO_OAUTH = {
    integrations: [Integration.OTTO, Integration.OTTO_PAYMENTS],
    identifier: "OTTO_OAUTH",
    name: "Otto",
};
const EBAY_OAUTH = {
    integrations: [Integration.EBAY, Integration.EBAY_PAYMENTS],
    identifier: "EBAY_OAUTH",
    name: "eBay",
};
const PAYPAL = {
    integrations: [Integration.PAYPAL],
    identifier: "PAYPAL",
    name: "PayPal Connect",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/paypal-api-verbinden",
};
const SHOPIFY_APPSTORE_BILLING = {
    integrations: [],
    identifier: "SHOPIFY_APPSTORE_BILLING",
    name: "Rechnungsprinter Pro > DATEV",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/shopify#shopify-setup-mit-pathway",
};
const SHOPIFY_APPSTORE_PLATFORM = {
    integrations: [Integration.SHOPIFY, Integration.SHOPIFY_PAYMENTS, Integration.SHOPIFY_POS],
    identifier: "SHOPIFY_APPSTORE_PLATFORM",
    name: "Buchhaltungsexport Pro > DATEV",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/shopify#shopify-setup-mit-pathway",
};
const SHOPIFY_PRIVATE_APP = {
    integrations: [Integration.SHOPIFY, Integration.SHOPIFY_PAYMENTS],
    identifier: "SHOPIFY_PRIVATE_APP",
    name: "Shopify (private App)",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/shopify#shopify-setup-mit-pathway",
};
const SHOPWARE = { integrations: [Integration.SHOPWARE], identifier: "SHOPWARE", name: "Shopware" };
const SNIPCART = { integrations: [Integration.SNIPCART], identifier: "SNIPCART", name: "Snipcart" };
const SQUARESPACE = { integrations: [Integration.SQUARESPACE], identifier: "SQUARESPACE", name: "Squarespace" };
const STRIPE_CONNECT = {
    integrations: [Integration.STRIPE, Integration.STRIPE_BILLING, Integration.STRIPE_PAYMENTS],
    identifier: "STRIPE_CONNECT",
    name: "Stripe Connect",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/stripe-billing#anleitungen",
};
const STRIPE_API_KEY = {
    integrations: [Integration.STRIPE, Integration.STRIPE_BILLING, Integration.STRIPE_PAYMENTS],
    identifier: "STRIPE_API_KEY",
    name: "Stripe Api Key",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/stripe-billing#anleitungen",
};
const TIKTOK_OAUTH = {
    integrations: [Integration.TIKTOK_PAYMENTS, Integration.TIKTOK_SHOP],
    identifier: "TIKTOK_OAUTH",
    name: "TikTok",
};
const UNZER = {
    integrations: [Integration.UNZER],
    identifier: "UNZER",
    name: "Unzer (Beta)",
};
const WOO_COMMERCE = {
    integrations: [Integration.WOO_COMMERCE],
    identifier: "WOO_COMMERCE",
    name: "WooCommerce",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/woocommerce#woocommerce-setup-mit-pathway",
};

const XENTRAL = {
    integrations: [Integration.XENTRAL],
    identifier: "XENTRAL",
    name: "Xentral",
    helpUrl: "https://hilfe.pathway-solutions.de/de/knowledge/xentral-api-erstellung",
};

const ZALANDO = {
    integrations: [Integration.ZALANDO, Integration.ZALANDO_PAYMENTS],
    identifier: "ZALANDO",
    name: "Zalando",
};

const VETEVO = {
    integrations: [Integration.VETEVO],
    identifier: "VETEVO",
    name: "Vetevo",
};

const WECLAPP = {
    integrations: [Integration.WECLAPP],
    identifier: "WECLAPP",
    name: "Weclapp",
};

const KAUFLAND = {
    integrations: [Integration.KAUFLAND, Integration.KAUFLAND_PAYMENTS],
    identifier: "KAUFLAND",
    name: "Kaufland",
};

export const AuthDataIdentifier = {
    ABOUT_YOU_API_KEY: ABOUT_YOU_API_KEY.identifier,
    ADYEN: ADYEN.identifier,
    AMAZON: AMAZON.identifier,
    AMAZON_PAY: AMAZON_PAY.identifier,
    AMAZON_PAY_V2: AMAZON_PAY_V2.identifier,
    BILLBEE: BILLBEE.identifier,
    BRAINTREE: BRAINTREE.identifier,
    CHARGEBEE: CHARGEBEE.identifier,
    FASTBILL: FASTBILL.identifier,
    GOCARDLESS: GOCARDLESS.identifier,
    DATEV_UO: DATEV_UO.identifier,
    DATEV_UO_REF: DATEV_UO_REF.identifier,
    KLARNA: KLARNA.identifier,
    LEX_OFFICE: LEX_OFFICE.identifier,
    MOLLIE: MOLLIE.identifier,
    MOLLIE_ACCESS_KEY: MOLLIE_ACCESS_KEY.identifier,
    OTTO_OAUTH: OTTO_OAUTH.identifier,
    EBAY_OAUTH: EBAY_OAUTH.identifier,
    KAUFLAND: KAUFLAND.identifier,
    PAYPAL: PAYPAL.identifier,
    SHOPIFY_APPSTORE_BILLING: SHOPIFY_APPSTORE_BILLING.identifier,
    SHOPIFY_APPSTORE_PLATFORM: SHOPIFY_APPSTORE_PLATFORM.identifier,
    SHOPIFY_PRIVATE_APP: SHOPIFY_PRIVATE_APP.identifier,
    SHOPWARE: SHOPWARE.identifier,
    SNIPCART: SNIPCART.identifier,
    SQUARESPACE: SQUARESPACE.identifier,
    STRIPE_CONNECT: STRIPE_CONNECT.identifier,
    STRIPE_API_KEY: STRIPE_API_KEY.identifier,
    TIKTOK_OAUTH: TIKTOK_OAUTH.identifier,
    UNZER: UNZER.identifier,
    WOO_COMMERCE: WOO_COMMERCE.identifier,
    VETEVO: VETEVO.identifier,
    WECLAPP: WECLAPP.identifier,
    XENTRAL: XENTRAL.identifier,
    ZALANDO: ZALANDO.identifier,
};

export const AuthDataType = {
    ABOUT_YOU_API_KEY,
    ADYEN,
    AMAZON,
    AMAZON_PAY,
    AMAZON_PAY_V2,
    BILLBEE,
    BRAINTREE,
    CHARGEBEE,
    EBAY_OAUTH,
    KAUFLAND,
    FASTBILL,
    GOCARDLESS,
    DATEV_UO,
    DATEV_UO_REF,
    KLARNA,
    LEX_OFFICE,
    MOLLIE,
    MOLLIE_ACCESS_KEY,
    OTTO_OAUTH,
    PAYPAL,
    SHOPIFY_APPSTORE_BILLING,
    SHOPIFY_APPSTORE_PLATFORM,
    SHOPIFY_PRIVATE_APP,
    SHOPWARE,
    SNIPCART,
    SQUARESPACE,
    STRIPE_CONNECT,
    STRIPE_API_KEY,
    TIKTOK_OAUTH,
    UNZER,
    WOO_COMMERCE,
    VETEVO,
    WECLAPP,
    XENTRAL,
    ZALANDO,
};

export const findAuthDataForIntegrationIdentifier = (integrationIdentifier) => {
    return Object.values(AuthDataType).filter((authDataType) =>
        authDataType.integrations.map((integration) => integration.identifier).includes(integrationIdentifier)
    );
};
